<template>
  <div class="octobus__price has-text-primary is-size-5-touch">
    <p class="old-price has-text-dark has-text-weight-normal" v-if="hasDiscount">{{ price.withoutDiscount | currency(currencySymbol) }}</p>
    <p>{{price.total | currency(currencySymbol)}}</p>
  </div>
</template>

<script>
export default {
  name: 'Price',
  props: {
    price: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasDiscount() {
      return Number(this.price.withoutDiscount) !== Number(this.price.total);
    },
    currencySymbol() {
      const name = this.$root.octobusCurrency ? this.$root.octobusCurrency.name : '';
      const currency = name || this.$root.octobusCurrencyObj;

      return typeof currency === 'object' ? currency.name : currency;
    },
  },
};
</script>

<style lang="scss" scoped>
.old-price {
  text-decoration: line-through;
}
</style>



// WEBPACK FOOTER //
// src/components/Passenger/Price.vue